module.exports = __webpack_public_path__ + "img/62cdc30.svg";